import { useContext } from 'react';

import { ToastMessagesContext } from '../contexts';

/**
 * Hook used to consume toast messages service.
 * @returns {ToastService} Toast messages service reference
 */
export const useToastMessages = () => {
  const { service } = useContext(ToastMessagesContext);
  return service;
};
